import React from "react";
import "./portfolio.css";
import IMG1 from "../../assets/portfolio__7.png";
import IMG2 from "../../assets/portfolio__8.png";
import IMG3 from "../../assets/portfolio__9.png";
import IMG4 from "../../assets/portfolio__10.png";
import IMG5 from "../../assets/portfolio__11.png";
import IMG6 from "../../assets/portfolio__12.png";

// portfolios project
const data = [
  {
    id: 0,
    image: IMG1,
    title: "🎓 FricaLearn LMS - Learning Management System",
    description:
      "Enterprise EdTech platform built with Laravel & React.js featuring payment integration, gamification, real-time chat, and AI-powered features.",
    demo: "https://fricalearn.com",
    featured: true,
  },
  {
    id: 2,
    image: IMG2,
    title: "Rufadem Communications",
    description:
      "Corporate website for a communications and PR agency, designed to showcase services and drive client inquiries.",
    demo: "https://rufadem.vercel.app/",
  },
  {
    id: 3,
    image: IMG3,
    title: "DED Luxury Car Hire & Rentals",
    description:
      "Booking-focused website for a luxury car hire service, with a fleet showcase and streamlined rental inquiry flow.",
    demo: "https://www.dedluxury.com/",
  },
  {
    id: 4,
    image: IMG4,
    title: "Goldengreys LLC",
    description:
      "Business website built to establish Goldengreys' online presence and communicate its products and services clearly.",
    demo: "https://goldengreys.com/",
  },
  {
    id: 5,
    image: IMG5,
    title: "Hikish Digitals Website Design & Development",
    description:
      "Official site for my agency, The Hikish Digitals — presenting our web design, development, and tech training services.",
    demo: "https://hikishdigital.com.ng/",
  },
  {
    id: 6,
    image: IMG6,
    title: "AFIWEL Official Website",
    description:
      "Official organizational website for AFIWEL, built to communicate its mission and connect with its audience online.",
    demo: "https://afiwel.com",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, demo, description, featured }) => {
          return (
            <article
              key={id}
              className={`portfolio__item ${
                featured ? "portfolio__item--featured" : ""
              }`}
            >
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
                {featured && (
                  <span className="portfolio__badge">⭐ Featured Project</span>
                )}
              </div>

              <h3>{title}</h3>
              {description && (
                <p className="portfolio__description">{description}</p>
              )}

              <div className="portfolio__item-cta">
                <a href={demo} className="btn btn-primary" target="__blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
